<template>
  <div class="container">
    <div style="margin-bottom: 20px">
      <label style="margin-right: 8px">单据编号</label>
      <span v-if="!!outbound.id">{{ outbound.code }}</span>
      <el-input v-else v-model="outbound.code" style="width: 150px"></el-input>
      <label style="margin-left: 12px; margin-right: 8px">出库仓库</label>
      <span v-if="readOnly">{{ outbound.warehouseId | valueName('Warehouse') }}
      - {{ outbound.warehousePosId | valueName('WarehousePos') }}</span>
      <warehouse-select v-else v-model="outbound.warehouse"></warehouse-select>
      <label style="margin-left: 12px; margin-right: 8px">出库日期</label>
      <span v-if="readOnly">{{ outbound.outDate }}</span>
      <el-date-picker v-else style="max-width: 130px;"
                      v-model="outbound.outDate"
                      type="date"
                      format="yyyy-MM-dd"
                      placeholder="选择日期">
      </el-date-picker>
      <label style="margin-left: 12px; margin-right: 8px">经办人</label>
      <span v-if="readOnly">{{ outbound.operatorUserName }}</span>
      <remote-select v-else class-name="OubtboundUser" v-model="outbound.operatorUserAccount"
                     :options="outboundUserOptions" selectFirst>
      </remote-select>
    </div>
    <el-table :data="outbound.goodsList" class="table-border" header-cell-class-name="table-head"
              :max-height="tableHeight">
      <el-table-column type="index" label="序号"></el-table-column>
      <el-table-column label="商品名称" prop="name"></el-table-column>
      <el-table-column label="商品编号" prop="code"></el-table-column>
      <el-table-column label="商品类型">
        <template #default="{row}">
          {{ row.typeCode | valueName('GOODS_TYPE') }}{{ row.typeCode }}
        </template>
      </el-table-column>
      <el-table-column label="单位" prop="unit">
        <template #default="{row}">
          <div>{{row.selectedUnit}}</div>
        </template>
      </el-table-column>
      <el-table-column label="生产日期" prop="productionDate"></el-table-column>
      <el-table-column label="保质期天数" prop="expireDays"></el-table-column>
      <el-table-column label="单价（元）" prop="price"></el-table-column>
      <el-table-column label="数量" prop="num"></el-table-column>

      <el-table-column v-if="!readOnly" :width="120" align="center" fixed="right">
        <template #header>
          <el-button type="primary" @click="selectGoods">商品选择</el-button>
        </template>
        <template #default="{row}">
          <el-button type="text" size="mini" @click="deleteGoods(row)" class="danger">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div style="display: flex; margin-top: 20px; justify-content: space-between">
      <div style="display: flex; align-items: center">
        <label style="width: 70px">物流公司</label>
        <el-input :disabled="readOnly" v-model="outbound.logisticsCompany"></el-input>
      </div>
      <div style="display: flex; align-items: center;">
        <label style="width: 70px">物流单号</label>
        <el-input :disabled="readOnly" v-model="outbound.logisticsCode" style="flex-shrink: 1"></el-input>
      </div>
      <div style="display: flex; align-items: center;">
        <label style="width: 70px">运费金额</label>
        <el-input :disabled="readOnly" v-model="outbound.freight"></el-input>
      </div>
      <div style="display: flex; align-items: center;">
        <label style="width: 70px">结算账户</label>
        <el-input :disabled="readOnly" v-model="outbound.settlementAccount"></el-input>
      </div>
    </div>
    <div style="margin-top: 20px; display: flex">
      <label style="width: 30px">备注</label>
      <el-input :disabled="readOnly" type="textarea" :rows="4" v-model="outbound.remarks" maxlength="200"
                resize="none"></el-input>
    </div>

    <div style="float: right; margin-top: 20px;">
      <template v-if="!readOnly">
        <el-button type="primary" @click="applyOutbound">出 库</el-button>
        <el-button @click="save">保 存</el-button>
        <el-button @click="cancel">取 消</el-button>
      </template>
      <el-button v-else @click="cancel">返 回</el-button>
    </div>

    <select-out-goods-dialog :visible.sync="dialog.show" :outbound="dialog.outbound"
                             :cand-goods-list="goodsList"
                             @update="updateGoodsList"></select-out-goods-dialog>
  </div>
</template>

<script>

import { resizeCaptureMixin } from '@/views/mixins/ResizeCapture'
import WarehouseSelect from '@/components/selector/WarehouseSelect'
import RemoteSelect from '@/components/selector/RemoteSelect'
import SelectOutGoodsDialog from '@/views/outbound/SelectOutGoodsDialog'
import { findGoods } from '@/utils/request'
import { Outbound } from '@/store/objdef/objectDef'
import authority from '@/utils/authority'

export default {
  name: 'OutboundGoods',
  mixins: [resizeCaptureMixin],
  components: { SelectOutGoodsDialog, RemoteSelect, WarehouseSelect },
  data () {
    return {
      outbound: new Outbound(),
      dialog: {
        show: false,
        outbound: new Outbound()
      },
      goodsList: null,
      oldOutbound: null
    }
  },
  created () {
    this.$store.dispatch('data/kvList', 'OutboundUser')
    this.$store.dispatch('outbound/all').then(list => {
      for (const outbound of list) {
        if (outbound.id.toString() === this.$route.query.outboundId) {
          this.outbound = outbound
          this.oldOutbound = this.$_.cloneDeep(this.outbound)
          break
        }
      }
    })
  },
  methods: {
    selectGoods () {
      if (!this.outbound.warehouse || !this.outbound.warehouse[1]) {
        this.$alert('请选择仓库！')
        return
      }
      this.dialog.outbound = this.$_.cloneDeep(this.outbound)
      this.dialog.show = true
    },
    edit (goods) {
      this.dialog.readOnly = false
      this.dialog.goods = this.$_.cloneDeep(goods)
      this.dialog.show = true
    },
    deleteGoods (goods) {
      this.$confirm(`确认删除商品【${goods.name}】, 是否继续?`, '提示', {
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        for (const index in this.outbound.goodsList) {
          const item = this.outbound.goodsList[index]
          if (item.id === goods.id) {
            this.outbound.goodsList.splice(index, 1)
          }
        }
      }).catch(() => {
      })
    },
    updateGoodsList (goodsList) {
      this.outbound.goodsList = goodsList
    },
    applyOutbound () {
      if (!this.check()) return
      if (this.outbound.goodsList.length === 0) {
        this.$alert('请选择商品！')
        return
      }
      this.outbound.status = 2
      this.save()
    },
    save () {
      if (!this.check()) return
      if (typeof this.outbound.outDate === 'object') {
        this.outbound.outDate = this.outbound.outDate.format('yyyy-MM-dd')
      }
      const isAdd = !this.outbound.id
      this.$store.dispatch('outbound/' + (isAdd ? 'add' : 'updateOne'), this.$_.cloneDeep(this.outbound)).then(() => {
        this.$router.go(-1)
        this.$message.success((this.outbound.status === 0 ? '保存' : '出库') + '成功!')
      })
    },
    cancel () {
      this.$router.go(-1)
    },
    check () {
      if (!this.outbound.warehouse || !this.outbound.warehouse[1]) {
        this.$alert('请选择仓库！')
        return false
      }
      if (!this.outbound.outDate) {
        this.$alert('请选择出库日期！')
        return false
      }
      return true
    }
  },
  computed: {
    tableHeight () {
      return this.clientHeight - 224 - 50
    },
    readOnly () {
      return this.outbound.status !== 0 || !this.$hasPermission(authority.OUTBOUND)
    },
    outboundUserOptions () {
      const options = [{ id: this.$store.state.user.userAccount, name: this.$store.state.user.name }]
      for (const item of this.$store.state.data.OutboundUser || []) {
        options.push({ id: item.account, name: item.name })
      }
      return options
    }
  },
  watch: {
    'outbound.warehouse': {
      handler (warehouse) {
        if (warehouse && warehouse[1]) {
          findGoods({ warehouseId: warehouse[0], warehousePosId: warehouse[1] }).then(resp => {
            this.goodsList = resp.data
            if (this.oldOutbound) {
              for (const goods of this.goodsList) {
                for (const oldGoods of this.oldOutbound.goodsList) {
                  if (goods.id === oldGoods.id && goods.inboundId === oldGoods.inboundId) {
                    goods.remain += oldGoods.num
                    break
                  }
                }
              }
            }
          })
        }
      },
      immediate: true
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ th {
  height: 50px;
}

label {
  margin-right: 10px;
  font-size: 13px;
  color: #646464;
}
</style>
